<template>
    <div>
        <v-btn @click="clickInput" :class="{ 'rounded-btn': true, w100: $vuetify.breakpoint.xsOnly }" color="info">{{ $t('Загрузить файл') }}</v-btn>
        <input style="display: none" type="file" ref="file" accept="text/xml" name="file" @change="processFile($event)" id="file-input" />
        <ConfirmDialog
            :ref="confirmDialogRef"
            :body="$t('Вы действительно хотите загрузить файл', { filename: fileName })"
            :yesText="$t('Загрузить')"
            :noText="$t('Отмена')"
            :width="450"
        />
    </div>
</template>

<script>
import ConfirmDialog from '../../../ui/ConfirmDialog';
import { mapActions } from 'vuex';
import { wait } from '../../../../utils/index';
export default {
    data: () => ({
        confirmDialogRef: 'confirmDialogRef',
        fileName: null
    }),
    components: { ConfirmDialog },
    methods: {
        ...mapActions('uploads', ['uploadFile', 'previewFile', 'getUploadsList', 'getFileDetail', 'getGroupedData']),

        clickInput() {
            this.$refs.file.click();
        },

        async processFile(evt) {
            this.fileName = evt.target.files[0].name;
            const answer = await this.$refs[this.confirmDialogRef].show();
            if (!answer) return this.resetInput();
            let formData = new FormData();
            formData.append('file', evt.target.files[0]);
            let response = await this.uploadFile(formData);

            if (response && response._rid) {
                this.resetInput();
                this.$router.push({ name: 'UploadsDetail', params: { id: response._rid } });
                await this.previewFile(response._rid);
                await wait(500);
                await this.getFileDetail(response._rid);
                await this.getGroupedData(response._rid);
            }

            await this.getUploadsList();
            if (document.getElementById('file-input')) {
                this.resetInput();
            }
        },
        resetInput() {
            document.getElementById('file-input').value = '';
        }
    }
};
</script>

<style></style>
